import { VariableSelectFeatureFlag } from '@makyoapp/makyo-common'

export function hasVariableSelectFeatureFlag(flags: VariableSelectFeatureFlag, lookup: VariableSelectFeatureFlag) {
  return (flags & lookup) === lookup
}
